var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0033 7.27637C16.0033 6.72408 15.5556 6.27637 15.0033 6.27637C14.4511 6.27637 14.0033 6.72408 14.0033 7.27637H16.0033ZM15.0033 18.6296L14.2962 19.3368C14.6868 19.7273 15.3199 19.7273 15.7104 19.3368L15.0033 18.6296ZM20.5523 14.4949C20.9428 14.1044 20.9428 13.4712 20.5523 13.0807C20.1618 12.6902 19.5286 12.6902 19.1381 13.0807L20.5523 14.4949ZM10.8686 13.0807C10.4781 12.6902 9.84492 12.6902 9.45439 13.0807C9.06387 13.4712 9.06387 14.1044 9.45439 14.4949L10.8686 13.0807ZM14.0033 7.27637V18.6296H16.0033V7.27637H14.0033ZM15.7104 19.3368L20.5523 14.4949L19.1381 13.0807L14.2962 17.9225L15.7104 19.3368ZM15.7104 17.9225L10.8686 13.0807L9.45439 14.4949L14.2962 19.3368L15.7104 17.9225Z",
    fill: "#1890FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7311 19.1416V22.2125C23.7311 22.4948 23.5022 22.7237 23.2199 22.7237H6.77965C6.49731 22.7237 6.26843 22.4948 6.26843 22.2125V19.1416",
    stroke: "#1890FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.cadf0c5ae6fc36b3a7ec40fc40f73fba.svg";
export { ForwardRef as ReactComponent };